// form ids

export const formEnterpriseAgencyId = '41c09cc3-04b1-4bb4-8976-cbca6a8031e3';

export const formSignupRegistrationPageId =
  'c9f9ae60-f8da-4e14-b6ab-51462c3d48a5';

export const formSignupRegistrationVersionB =
  '010b042d-50aa-4847-911a-b9e40cf87322';

export const formWebinar = 'f1ff635d-adfc-4d42-b687-51fe14fc65f0';

// Ebooks
export const formEbook = '112116cd-981a-4630-bc6c-755c18d30bb7';
export const formEbookHandoff = 'fcd334fa-e953-4735-a4e7-f3b6e9556f43';
export const formEbookDesignSystems = 'f13b566c-9ae5-4b07-9cf0-824bbbeda4bb';

export const formContactUs = '322c2e2b-4e22-4235-b2d8-95795e238dc8';

// Event ids

export const ENTERPRISE_PAGE_REQUEST_A_TRIAL_CLICKED = '000006280074';

// Request Demo form
export const formEnterpriseRequestQuoteId =
  '4e3319a8-fe9b-497a-a1db-7b1b8e177301';
export const formEnterpriseRequestDemoFromAppId =
  'f4d82fcc-a95a-41e5-adcd-239e9510d408';

// Enterprise request forms
export const requestMarvel3FormId = '220fafe8-be1f-40bc-8a64-23fcf3ca89c9';
export const requestDemoAgencyId = '41c09cc3-04b1-4bb4-8976-cbca6a8031e3';
export const requestDemoFinanceId = 'b5597e01-81a1-422e-bb9a-758542680223';
export const requestDemoConsultancyId = 'eca14ad9-44c8-429e-b593-ed8864f6367b';
export const requestDemoUTModalUpsell = '8c8723cd-f73d-414b-99b5-81273bb567f0';
export const requestDemoUTLandingPageId =
  '90e18c76-6c19-40e4-8792-4447e2f3ab0f';
export const requestDemoInvisionSwitchId =
  '8b7cab62-c30b-493d-b064-f8288f3d16ba';

// Enterprise request form page content
const enterpriseForms = {
  // The pricing page enterprise form doesn't render features from this list
  // but we need it to reference the form name to send to the backend
  [formEnterpriseRequestQuoteId]: {
    formName: 'Request Quote from Pricing Page',
  },
  [formEnterpriseRequestDemoFromAppId]: {
    formName: 'Product Lead in app',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestMarvel3FormId]: {
    formName: 'Marvel 3 Enterprise Page',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestDemoAgencyId]: {
    formName: 'Agency Page',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestDemoFinanceId]: {
    formName: 'Finance Page',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestDemoConsultancyId]: {
    formName: 'Consultancy Page',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestDemoUTLandingPageId]: {
    formName: 'User Testing Page',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: 'Platform + User Testing API access and developer support',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
  [requestDemoUTModalUpsell]: {
    formName: 'User Testing Modal',
    title:
      'Join 85% of the Fortune 100 and scale your design and testing process with Marvel Enterprise.',
    features: [
      {
        feature: 'Unlimited projects, prototyping and user testing',
        tooltip: null,
      },
      {
        feature: 'Unlimited team members and guests',
        tooltip: null,
      },
      {
        feature:
          'Single Sign-On (SSO) with support for Okta, One Login and many more',
        tooltip: null,
      },
      {
        feature: 'Team security features including IP and access restriction',
        tooltip: null,
      },
      {
        feature: 'Onboarding and training including design thinking workshops',
        tooltip: null,
      },
      {
        feature: '99.9% uptime SLA',
        tooltip: null,
      },
      {
        feature: 'Priority support and dedicated customer manager',
        tooltip: null,
      },
    ],
  },
};

export const getEnterpriseFormContent = hubspotFormId => {
  // Fallback to this id if the page is loaded with hformid that isn't recognized
  const FALLBACK_FORM_ID = formEnterpriseRequestDemoFromAppId;
  return enterpriseForms[hubspotFormId] || enterpriseForms[FALLBACK_FORM_ID];
};



// WEBPACK FOOTER //
// ./src/configs/hubspot.js